document.addEventListener("DOMContentLoaded", () => {
  // Select all accordion wrappers
  const accordionWrappers = document.querySelectorAll(".accordion");

  accordionWrappers.forEach(wrapper => {
    const sectionId = wrapper.dataset.sectionId; // dynamic section ID
    const items = wrapper.querySelectorAll(".accordion__item");

    console.log("Accordion Section ID:", sectionId, "Items found:", items.length);

    items.forEach((item, index) => {
      const btn = item.querySelector(".accordion__item-btn");
      const content = item.querySelector(".accordion__item-desc");

      // If open by default
      if (item.classList.contains("open")) {
        content.style.maxHeight = content.scrollHeight + "px";
      }

      btn?.addEventListener("click", () => {
        const isOpen = item.classList.contains("open");

        // Close all items in this section
        items.forEach(i => {
          i.classList.remove("open");
          i.querySelector(".accordion__item-desc").style.maxHeight = null;
        });

        // Toggle this one
        if (!isOpen) {
          item.classList.add("open");
          content.style.maxHeight = content.scrollHeight + "px";
        }

        console.log(`Section ${sectionId}, item ${index} clicked. Open?`, !isOpen);
      });
    });
  });
});

// HIDE AND SHOW OF STICKY QUANTITY, VARIANTS, ADD TO CART

document.addEventListener("DOMContentLoaded", function () {
  const windowWidth = window.innerWidth;
  const height = windowWidth > 750 ? 540 : 1000;

  window.addEventListener("scroll", function () {
    const scroll = window.scrollY || window.pageYOffset;

    const stickyATC = document.querySelector(".sticky_atc");
    if (!stickyATC) return;

    if (scroll > height) {
      stickyATC.classList.add("show");
    } else {
      stickyATC.classList.remove("show");
    }
  });
});


// ADD TO CART BUTTON FUNCTIONING

const firstAddToCartButton = document.querySelector('.sticky_atc_btn');
const secondAddToCartButton = document.querySelector('.custom-add-to-cart-button');
firstAddToCartButton?.addEventListener('click', function() {
    if (secondAddToCartButton) {
        secondAddToCartButton.click();
    }
});


//QUANTITY CHANGE 

document.addEventListener("DOMContentLoaded", function() {
  // Get the main and sticky buttons
  const stickyDecButton = document.querySelector('.sticky_quantity__button_dec');
  const stickyIncButton = document.querySelector('.sticky_quantity__button_inc');
  const mainDecButton = document.querySelector('.main_quantity__button_dec');
  const mainIncButton = document.querySelector('.main_quantity__button_inc');
  
  // When sticky decrease button is clicked, trigger main decrease button click
  stickyDecButton?.addEventListener('click', function() {
    mainDecButton.click();
  });

  // When sticky increase button is clicked, trigger main increase button click
  stickyIncButton?.addEventListener('click', function() {
    mainIncButton.click();
  });

});


document.addEventListener("DOMContentLoaded", function() {
  // Get the buttons and input field for the sticky quantity control
  const stickyDecButton = document.querySelector('.main_quantity__button_dec');
  const stickyIncButton = document.querySelector('.main_quantity__button_inc');
  const stickyInput = document.querySelector('.sticky_quantity__input');
  const main_quantity_input = document.querySelector('.main_quantity_input');

  stickyDecButton?.addEventListener('click', function() {
    console.log('pressing dec button')
      stickyInput.value = main_quantity_input.value;
  });

  stickyIncButton?.addEventListener('click', function() {
    console.log('pressing inc button')
    stickyInput.value = main_quantity_input.value;
  });
});

// VARIANTS WORKING

document.addEventListener('DOMContentLoaded', function() {
  // Listen for changes on the variant dropdown
  document.getElementById('sticky_variant-selector')?.addEventListener('change', function() {

    // Get the selected option and its attributes
    const selectedOption = this.selectedOptions[0];
    const selectedVariantId = selectedOption.getAttribute('data_id');
    const selectedColor = selectedOption.value;
    const imageSrc = selectedOption.getAttribute('img_src');
    
    // Update the hidden input with the selected variant ID
    document.querySelector('.product-variant-id').value = selectedVariantId;

    // Uncheck all radio buttons for color options
    document.querySelectorAll('.main-prd-variant_input').forEach(function(radioButton) {
      radioButton.checked = false;
    });

    // Check the radio button corresponding to the selected color
    const selectedRadio = document.querySelector(`.main-prd-variant_input-${selectedColor}`);
    if (selectedRadio) {
      selectedRadio.checked = true;
    }

    // Update the image source and alt text
    const imgElement = document.querySelector('.sticky_atc_Image img');
    if (imgElement) {
      imgElement.src = imageSrc;
      // imgElement.alt = selectedOption.textContent || selectedOption.innerText;
    }

  });
});

document.addEventListener('click', (event) => {
  // Check if the clicked element has the class 'main-prd-variant'
  if (event.target.classList.contains('main-prd-variant')) {
    // Extract the label index from the 'index_no' attribute (adjusted for zero-based index)
    const labelIndex = parseInt(event.target.getAttribute('index_no'), 10) - 1;
    console.log('labelIndex:', labelIndex);

    // Call a function to update the dropdown based on the label index
    change_variant_color(labelIndex);
  }
});

// Function to change the variant color in the select dropdown based on the labelIndex
function change_variant_color(labelIndex) {
  // Get the select dropdown
  const select = document.getElementById('sticky_variant-selector');
  
  // Get the options from the select dropdown
  const options = select.querySelectorAll('option');

  // Ensure we have a valid index and select the corresponding option
  if (labelIndex >= 0 && labelIndex < options.length) {
      // Set the selected option based on the label index
      options[labelIndex].selected = true;

      // Simulate a click event on the selected option
      // options[labelIndex].dispatchEvent(new MouseEvent('click'));

      // Get the image source (img_src attribute) from the selected option
      const imgSrc = options[labelIndex].getAttribute('img_src');

      // Update the image source in the sticky_atc_Image div
      const imageElement = document.querySelector('.sticky_atc_Image img');
      imageElement.src = imgSrc;
  }
}


document.querySelectorAll('.click-block a').forEach(function(link) {
  link?.addEventListener('click', function(e) {
    // Optional: smooth scroll if the link is an internal hash
    const targetId = this.getAttribute('href');
    if (targetId.startsWith('#')) {
      e.preventDefault(); // prevent default jump
      const target = document.querySelector(targetId);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
    }
    // Otherwise, let the link behave normally for external URLs
  });
});

// document.querySelectorAll('.size_chat-image_container').forEach(element => {
//   element?.addEventListener('click', () => {
//     element.style.display = 'none';
//     document.body.style.overflow = "scroll"; // corrected
//     document.querySelector(".header-section").style.zIndex = "9999";
//   });
// });
// document.querySelector('.size_image-button')?.addEventListener('click', () => {
//   const container = document.querySelector('.size_chat-image_container');
//   container.style.display = 'flex';
//   document.body.style.overflow = "hidden"; // corrected
//   document.querySelector(".header-section").style.zIndex = "-1";
// });

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.size_chat-image_container').forEach(function (container) {
    document.body.appendChild(container);
  });
});

document.addEventListener('click', function (e) {

  const button = e.target.closest('.size_image-button');
  if (button) {
    const sectionId = button.getAttribute('data-section');

    const container = document.querySelector(
      `.size_chat-image_container[data-section="${sectionId}"]`
    );

    if (!container) {
      console.log("Container not found for section:", sectionId);
      return;
    }

    container.style.display = 'flex';
    document.body.style.overflow = "hidden";
  }

  const closeBtn = e.target.closest('.size_chat-btn');
  if (closeBtn) {
    const container = closeBtn.closest('.size_chat-image_container');
    if (container) {
      container.style.display = 'none';
      document.body.style.overflow = "scroll";
    }
  }

});

// Select the first element with .show-in_mobile
const mobileElement = document.querySelector('.show-in_mobile');

window.addEventListener('scroll', () => {
  if (!mobileElement) return; // Safety check

  if (window.scrollY > 50) {
    mobileElement.classList.add('bg-white_sticky');
  } else {
    mobileElement.classList.remove('bg-white_sticky');
  }
});

// Select the cart icon
const cartIcon = document.querySelector('.cus-header__icon--cart_main');

// Select the cart drawer
const cartDrawer = document.querySelector('cart-drawer');

// Add click event listener
cartIcon?.addEventListener('click', () => {
  cartDrawer.classList.add('active');
});


// document.addEventListener("DOMContentLoaded", function () {

//   const searchDetails = document.querySelector(".cus-search-box details");

//   if (!searchDetails) return;

//   // 1️⃣ Default open
//   searchDetails.setAttribute("open", "");

//   // 2️⃣ Agar koi close kare toh turant wapas open
//   searchDetails.addEventListener("toggle", function () {
//     if (!searchDetails.hasAttribute("open")) {
//       searchDetails.setAttribute("open", "");
//     }
//   });

//   // 3️⃣ Outside click se close na ho
//   document.addEventListener("click", function () {
//     if (!searchDetails.hasAttribute("open")) {
//       searchDetails.setAttribute("open", "");
//     }
//   });

// });

document.addEventListener("DOMContentLoaded", function () {

  const searchDetails = document.querySelector(".cus-search-box details");
  const searchBox = document.querySelector(".cus-search-box");
  const menuDrawer = document.querySelector("#Details-menu-drawer-container");

  if (!searchDetails || !searchBox || !menuDrawer) return;

  // 1️⃣ Default open
  searchDetails.setAttribute("open", "");

  // 2️⃣ Agar koi close kare toh turant wapas open
  searchDetails.addEventListener("toggle", function () {
    if (!searchDetails.hasAttribute("open") && !menuDrawer.hasAttribute("open")) {
      searchDetails.setAttribute("open", "");
    }
  });

  // 3️⃣ Outside click se close na ho
  document.addEventListener("click", function () {
    if (!searchDetails.hasAttribute("open") && !menuDrawer.hasAttribute("open")) {
      searchDetails.setAttribute("open", "");
    }
  });

  // 4️⃣ Hamburger open/close par search box hide/show
  menuDrawer.addEventListener("toggle", function () {

    if (menuDrawer.hasAttribute("open")) {
      // hamburger open → search box hide
      searchBox.style.display = "none";
    } else {
      // hamburger close → style remove
      searchBox.style.display = "";
    }

  });

});

// const words = ["Tops", "Dresses", "Shirts", "Gowns"];
//  const wordsString = document.querySelector('.placeholder-words').textContent.trim();
//   const words = wordsString.split(',').map(word => word.trim());
// const prefix = "Search for "; 
// const inputs = document.querySelectorAll(".custom-animation");

// inputs.forEach(input => {
//   let wordIndex = 0;
//   let charIndex = 0;
//   let deleting = false;
//   let delay = 200;
//   let typing = true;

//   input.addEventListener("focus", () => {
//     typing = false;
//     input.setAttribute("placeholder", "");
//   });

//   input.addEventListener("blur", () => {
//     typing = true;
//     charIndex = 0;      
//     deleting = false;    
//     type();         
//   });

//   function type() {
//     if (!typing) {
//       setTimeout(type, 300);
//       return;
//     }

//     const currentWord = words[wordIndex];

//     if (!deleting) {
//       input.setAttribute("placeholder", prefix + currentWord.substring(0, charIndex + 1));
//       charIndex++;
//       if (charIndex === currentWord.length) {
//         deleting = true;
//         delay = 500; // wait before deleting
//       } else {
//         delay = 300;
//       }
//     } else {
//       input.setAttribute("placeholder", prefix + currentWord.substring(0, charIndex - 1));
//       charIndex--;
//       if (charIndex === 0) {
//         deleting = false;
//         wordIndex = (wordIndex + 1) % words.length;
//         delay = 500; // wait before typing next word
//       } else {
//         delay = 300;
//       }
//     }

//     setTimeout(type, delay);
//   }

//   type();
// });


// Get words from DOM
// const wordsString = document.querySelector('.placeholder-words').textContent.trim();
// const words = wordsString.split(',').map(word => word.trim());

// // Prefix and bold text (using Unicode bold letters)
// const boldText = "Search for: "; // This is bold Unicode text
// const prefix = ""; 

// const inputs = document.querySelectorAll(".custom-animation");

// inputs.forEach(input => {
//   let wordIndex = 0;
//   let charIndex = 0;
//   let deleting = false;
//   let delay = 200;
//   let typing = true;

//   input.addEventListener("focus", () => {
//     typing = false;
//     input.setAttribute("placeholder", "");
//   });

//   input.addEventListener("blur", () => {
//     typing = true;
//     charIndex = 0;      
//     deleting = false;    
//     type();         
//   });

//   function type() {
//     if (!typing) {
//       setTimeout(type, 300);
//       return;
//     }

//     const currentWord = words[wordIndex];

//     if (!deleting) {
//       input.setAttribute("placeholder", boldText + prefix + currentWord.substring(0, charIndex + 1));
//       charIndex++;
//       if (charIndex === currentWord.length) {
//         deleting = true;
//         delay = 500; // wait before deleting
//       } else {
//         delay = 300;
//       }
//     } else {
//       input.setAttribute("placeholder", boldText + prefix + currentWord.substring(0, charIndex - 1));
//       charIndex--;
//       if (charIndex === 0) {
//         deleting = false;
//         wordIndex = (wordIndex + 1) % words.length;
//         delay = 500; // wait before typing next word
//       } else {
//         delay = 300;
//       }
//     }

//     setTimeout(type, delay);
//   }

//   type();
// });


// JavaScript
// const wordsString = document.querySelector('.placeholder-words').textContent.trim();
// const words = wordsString.split(',').map(word => word.trim());

// const prefix = ""; 
// const boldText = "Search For "; 

// const inputs = document.querySelectorAll(".custom-animation");

// inputs.forEach(input => {
//   const placeholderSpan = input.parentElement.querySelector(".animated-placeholder");

//   let wordIndex = 0;
//   let charIndex = 0;
//   let deleting = false;
//   let delay = 200;
//   let typing = true;

//   input.addEventListener("focus", () => {
//     typing = false;
//     placeholderSpan.innerHTML = ""; // Hide when typing
//   });

//   input.addEventListener("blur", () => {
//     typing = true;
//     charIndex = 0;      
//     deleting = false;    
//     type();         
//   });

//   function type() {
//     if (!typing) {
//       setTimeout(type, 300);
//       return;
//     }

//     const currentWord = words[wordIndex];

//     if (!deleting) {
//       placeholderSpan.innerHTML = `<span style="color:gray;font-weight:normal">${boldText}</span>${prefix}${currentWord.substring(0, charIndex + 1)}`;
//       charIndex++;
//       if (charIndex === currentWord.length) {
//         deleting = true;
//         delay = 500; // wait before deleting
//       } else {
//         delay = 300;
//       }
//     } else {
//       placeholderSpan.innerHTML = `<span style="color:gray;font-weight:normal">${boldText}</span>${prefix}${currentWord.substring(0, charIndex - 1)}`;
//       charIndex--;
//       if (charIndex === 0) {
//         deleting = false;
//         wordIndex = (wordIndex + 1) % words.length;
//         delay = 500; // wait before typing next word
//       } else {
//         delay = 300;
//       }
//     }

//     setTimeout(type, delay);
//   }

//   type();
// });

const wordsString = document.querySelector('.placeholder-words').textContent.trim();
const words = wordsString.split(',').map(word => word.trim());

const prefix = ""; 
const boldText = "Search For "; 

const inputs = document.querySelectorAll(".custom-animation");

inputs.forEach(input => {
  const placeholderSpan = input.parentElement.querySelector(".animated-placeholder");

  let wordIndex = 0;
  let charIndex = 0;
  let deleting = false;
  let delay = 200;
  let typing = true;

  // Hide animation if user types anything
  input.addEventListener("input", () => {
    if (input.value.length > 0) {
      typing = false;
      placeholderSpan.innerHTML = "";
    }
  });

  // Hide animation when focused
  input.addEventListener("focus", () => {
    typing = false;
    placeholderSpan.innerHTML = "";
  });

  // Show animation only when input is empty and blurred
  input.addEventListener("blur", () => {
    if (input.value.length === 0) {
      typing = true;
      charIndex = 0;
      deleting = false;
      type();
    }
  });

  function type() {
    if (!typing || input.value.length > 0 || document.activeElement === input) return;

    const currentWord = words[wordIndex];

    if (!deleting) {
      placeholderSpan.innerHTML = `<span style="color:gray;font-weight:normal">${boldText}</span>${prefix}${currentWord.substring(0, charIndex + 1)}`;
      charIndex++;
      if (charIndex === currentWord.length) {
        deleting = true;
        delay = 500;
      } else {
        delay = 300;
      }
    } else {
      placeholderSpan.innerHTML = `<span style="color:gray;font-weight:normal">${boldText}</span>${prefix}${currentWord.substring(0, charIndex - 1)}`;
      charIndex--;
      if (charIndex === 0) {
        deleting = false;
        wordIndex = (wordIndex + 1) % words.length;
        delay = 500;
      } else {
        delay = 300;
      }
    }

    setTimeout(type, delay);
  }

  // Start animation only if input is empty
  if (input.value.length === 0) type();
});

document.addEventListener('click', function(e) {

  const btn = e.target.closest('.zipcode_submit');
  if (!btn) return;

  const accordionItem = btn.closest('.accordion__item');

  // ✅ sirf tab run karo jab accordion open ho
  if (!accordionItem.classList.contains('open')) return;

  const container = accordionItem.querySelector('.accordion__item-desc');

  setTimeout(() => {
    container.style.maxHeight = container.scrollHeight + "px";
  }, 700);

});
